import type { Logger } from "@expert/logging";

import { useExpertNoteStore } from "../../state";
import { Notepad } from "./Notepad";

interface Props {
    logger: Logger;
}

/**
 * Renders the notepad from the store's open state. Mount once in an app shell that outlives the
 * timeline, so the notepad stays open (or closed) across calls, verification, and chat switches.
 * The Toolbox only toggles the store.
 */
export function NotepadHost({ logger }: Props) {
    const isOpened = useExpertNoteStore((state) => state.isOpened);
    const setIsOpened = useExpertNoteStore((state) => state.setIsOpened);

    return <Notepad opened={isOpened} onClose={() => setIsOpened(false, logger)} logger={logger} />;
}
